import { Box } from "@mui/system";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import useApi from "hooks/useApi";
import useFormatter from "hooks/useFormatter";
import moment from "moment";
import ReactLoading from "react-loading";
import { toast } from "react-toastify";

const DateColumn = ({ id, value, setAllData, onSubmit, onSuccess }) => {
  const { fetchData: updateData, loading: updateLoading } = useApi();
  const { formatDate } = useFormatter();

  const handleUpdateDate = async (newDate) => {
    try {
      const result = await updateData(onSubmit(newDate));

      if (result.success) {
        onSuccess
          ? onSuccess(newDate, result)
          : setAllData((prev) =>
              prev.map((data) => {
                if (data.id === id) {
                  return { ...data, ...result.data };
                }
                return data;
              }),
            );
      } else {
        toast.error(result.message);
      }
    } catch (error) {
      toast.error("Something went wrong!");
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        gap: "5px",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      {updateLoading ? (
        <ReactLoading type="bubbles" color="#000" height="30px" width="30px" />
      ) : (
        <span>{formatDate(value)}</span>
      )}
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <DatePicker
          disabled={updateLoading}
          label="Custom input"
          value={value}
          onChange={(newValue) => {
            const formattedDate = moment(newValue).format("YYYY-MM-DD");
            handleUpdateDate(formattedDate);
          }}
          renderInput={({ inputRef, inputProps, InputProps }) => (
            <Box sx={{ display: "flex", alignItems: "center" }}>
              {InputProps?.endAdornment}
              <input
                style={{ width: "0px", height: "0px", opacity: 0 }}
                ref={inputRef}
                {...inputProps}
              />
            </Box>
          )}
        />
      </LocalizationProvider>
    </Box>
  );
};

export default DateColumn;
